import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  toast: (props) => ({
    position: 'fixed',
    width: `calc(100vw - ${props.fullWidth ? 0 : theme.sizes.base * 4}px)`,
    margin: props.fullWidth ? 0 : theme.sizes.base * 2,
    left: 0,
    ...(props.position === 'top' ? { top: 0 } : { bottom: 0 }),
    zIndex: 70,
    opacity: 0,
    transitionProperty: ['transform', 'opacity'],
    transitionDuration: theme.speed.normal,
    '&.entering': {
      transform: 'translateY(0px)',
      opacity: 1,
    },
    '&.entered': {
      transform: 'translateY(0px)',
      opacity: 1,
    },
    '&.exiting': {
      transform: `translateY(${props.position === 'top' ? '-140%' : '140%'} )`,
      opacity: 0,
    },
    '&.exited': {
      transform: `translateY(${props.position === 'top' ? '-140%' : '140%'})`,
      opacity: 0,
    },
  }),

}));

export default useStyle;
